import React from "react"
import { remove, sortBy, orderBy } from "lodash"
import { v4 as uuid } from "uuid"

import { availableColorTheme, sortingTypes } from "Utils/widgetsUtils"

import {
  getArrayIntersections,
  getFieldsDisplayedButNotString,
  getFieldsListFromUUIDList,
  getFieldFromUUID,
  getDefaultAggFunction,
  getDefaultAggFunctionFromFieldType,
} from "Utils/dataCatalogueUtils.js"

import { newWidgetConstructor } from "Containers/Page/page.utils.js"

import { getMaximumNumberFields } from "Components/WidgetSettingsComponent/configurationContent.utils"

import { getWidgetDefaultProps } from "Utils/widgetConfiguration.js"

import { isFilterWidget, isTextWidget } from "Utils/widgetsUtils"

export const temporaryIdStr = "tempIdUntilChange"

export const groupByLimitList = [
  {
    type: "treeMap",
    limit: 4,
  },
  {
    type: "table",
    limit: 4,
  },
  {
    type: "histogram",
    limit: 2,
  },
  {
    type: "ag_table",
    limit: 1000,
  },
  {
    type: "evolutionWidget",
    limit: 1,
  },
  {
    type: "pyramide",
    limit: 2,
  },
  {
    type: "heatMap",
    limit: 2,
  },
  {
    type: "heatMapRisk",
    limit: 2,
  },
  {
    type: "radarChart",
    limit: 2,
  },
]

export const widgetTypeThatCanHaveSeveralGroupBy = groupByLimitList.map(elt => elt.type)

export const getCalculusOptionDependingonDataType = (configObject, partialTrad) => {
  var { fieldDataType, showDefaultValue } = configObject
  var showDefaultValueDependOnType =
    showDefaultValue && !configObject?.widgetType === "fillingGauge"
  var {
    DEFAULT,
    SUM,
    MEAN,
    MAXIMUM,
    MINIMUM,
    COUNT,
    COUNT_DISTINCT,
    PERCENTAGE,
    DATA_PERCENTAGE,
    LIST,
    DIVISION = "Division",
  } = partialTrad

  if (fieldDataType === undefined) return <></>
  return (
    <>
      {showDefaultValueDependOnType && <option value={""}>{DEFAULT?.toUpperCase()}</option>}
      <option value={"sum"}>{SUM?.toUpperCase()}</option>
      <option value={"array_agg"}>{LIST?.toUpperCase()}</option>
      <option value={"mean"}>{MEAN?.toUpperCase()}</option>
      <option value={"max"}>{MAXIMUM?.toUpperCase()}</option>
      <option value={"min"}>{MINIMUM?.toUpperCase()}</option>
      {fieldDataType === "Integer" && (
        <option value={"cumPercentage"}>{DATA_PERCENTAGE?.toUpperCase()}</option>
      )}
      {fieldDataType === "Array" && (
        <option value={"array_sumdiv"}>{DIVISION?.toUpperCase()}</option>
      )}
      {/* <option value={"overallPercentage"}>{PERCENTAGE?.toUpperCase()}</option> */}
      <option value={"count"}>{COUNT?.toUpperCase()}</option>
      <option value={"countDistinct"}>{COUNT_DISTINCT?.toUpperCase()}</option>
    </>
  )
}
export const getDisplayModeOptionPersonalization = trad => {
  return (
    <>
      <option value={""}>{trad?.BY_DEFAULT?.toUpperCase()}</option>
      <option value={"displayPersonalization"}>
        {trad?.DISPLAY_MODE_PERSONALIZATION?.toUpperCase()}
      </option>
    </>
  )
}

export const getDisplayModeOption = trad => {
  return (
    <>
      <option value={""}>{trad?.BY_DEFAULT?.toUpperCase()}</option>
      <option value={"displayLabel"}>{trad?.DISPLAY_LABEL?.toUpperCase()}</option>
      <option value={"displayValueAndColor"}>{trad?.DISPLAY_VALUE_AND_COLOR?.toUpperCase()}</option>
      <option value={"displayLabelAndColor"}>{trad?.DISPLAY_LABEL_AND_COLOR?.toUpperCase()}</option>
      <option value={"displayPersonalization"}>
        {trad?.DISPLAY_MODE_PERSONALIZATION?.toUpperCase()}
      </option>
    </>
  )
}

//It should be better to separate this function in 2.
//First get the source, then the name
export const getSourceNameFromFieldUuid = (fieldUuid, allSources, fieldsData) => {
  // var fieldFromUUID = getFieldFromUUID(fieldsData, fieldUuid)

  if (!Array.isArray(allSources)) return undefined
  var sourceFound = {}

  allSources.forEach(source => {
    var sourceColumns = source?.referential?.columns
    if (Array.isArray(sourceColumns)) {
      var columnDataFound = sourceColumns.find(column => column?.uuid === fieldUuid)
      if (columnDataFound !== undefined) {
        sourceFound = source?.name
      }
    }
  })

  if (Object.keys(sourceFound).length === 0) return ""

  return sourceFound
}

export const getSourcesNameObject = (allSources, fieldsData, uuidsFromWidget) => {
  const { uuidWidgetData, uuidWidgetGroupBy } = uuidsFromWidget
  var dataSourceName = getSourceNameFromFieldUuid(
    uuidWidgetData,
    allSources,

    fieldsData
  )
  var groupBySourceName = getSourceNameFromFieldUuid(
    uuidWidgetGroupBy,
    allSources,

    fieldsData
  )
  if (dataSourceName === undefined || groupBySourceName === undefined) return {}
  return {
    dataSourceName: dataSourceName,
    groupBySourceName: groupBySourceName,
  }
}

export const getFirstFieldUidInWidget = widgetInfo => {
  var widgetInfoGroupBy = widgetInfo?.groupBy
  var widgetInfoData = widgetInfo?.data
  var firstFieldUuidData = getFirstFieldUuidInData(widgetInfo)
  var firstFieldUuidGroupBy = getFirstFieldUuidInGroupBy(widgetInfo)

  var fieldDataIsEmpty = widgetInfoData.length === 0
  var fieldGroupByIsEmpty = widgetInfoGroupBy.length === 0
  if (fieldDataIsEmpty && fieldGroupByIsEmpty) return ""

  var fieldUuid = !fieldDataIsEmpty ? firstFieldUuidData : firstFieldUuidGroupBy
  return fieldUuid
}

export const getFirstFieldUuidInData = widgetInfo => {
  var widgetInfoData = widgetInfo?.data
  if (!Array.isArray(widgetInfoData) || widgetInfoData.length === 0) {
    return undefined
  }

  return widgetInfoData[0]?.uuid
}

export const getFirstFieldUuidInGroupBy = widgetInfo => {
  var widgetInfoGroupBy = widgetInfo?.groupBy
  if (!Array.isArray(widgetInfoGroupBy) || widgetInfoGroupBy.length === 0) {
    return undefined
  }

  return widgetInfoGroupBy[0]?.uuid
}

export const getSourceNameByDataSelectionType = (
  widgetInfo,
  allSources,

  fieldsData
) => {
  const uuidsFromWidget = {
    uuidWidgetData: getFirstFieldUuidInData(widgetInfo),
    uuidWidgetGroupBy: getFirstFieldUuidInGroupBy(widgetInfo),
  }
  const sourceNameObject = getSourcesNameObject(
    allSources,

    fieldsData,
    uuidsFromWidget
  )
  return sourceNameObject
}

export const formatColorPalettes = (
  businessColorPalettes,
  businessDefaultPaletteId,
  publicColorPalettes
) => {
  var colorPalette = {}
  var listColors = []
  var defaultColorPalette = ""

  if (businessColorPalettes.length) {
    const palettes = sortBy(businessColorPalettes, "name", "desc")

    for (let i = 0; i < palettes.length; i++) {
      colorPalette[palettes[i].name] = palettes[i].colors
      listColors.push({ value: palettes[i].name, name: palettes[i].name })
    }

    let palette = palettes.find(
      item =>
        item?._id?.$oid === businessDefaultPaletteId || item?.paletteId === businessDefaultPaletteId
    )

    if (palette) {
      defaultColorPalette = palette.name
    } else {
      defaultColorPalette = palettes[0]?.name
    }
  } else {
    if (publicColorPalettes.length) {
      const palettes = sortBy(publicColorPalettes, "name", "desc")
      for (let i = 0; i < palettes.length; i++) {
        colorPalette[palettes[i]?.name] = palettes[i]?.colors
        listColors.push({ value: palettes[i].name, name: palettes[i].name })
      }
      defaultColorPalette = palettes[0]?.name
    } else {
      colorPalette = availableColorTheme[0]
      defaultColorPalette = Object.keys(availableColorTheme)[0]
      listColors = Object.keys(availableColorTheme).map(color => ({
        value: color,
        name: color,
      }))
      listColors = listColors.reverse()
    }
  }

  return { colorPalette, listColors, defaultColorPalette }
}

export const getDataNamesFromWidgetElementList = (elementList, fieldsData) => {
  var newDataNames = []
  if (elementList.length && fieldsData.length) {
    newDataNames = elementList.map(dataFieldObj => {
      let field = fieldsData.find(field => field.uuid === dataFieldObj.id)
      var dataNameToReturn = field && field?.tags?.label ? field.tags.label : "undefined"
      if (dataFieldObj?.name && dataFieldObj.name !== "") dataNameToReturn = dataFieldObj.name
      return dataNameToReturn
    })
  }
  return newDataNames
}

export const getNewRequestInformations = (elementList, widgetInfo, fieldsData, removalConfig) => {
  //REQUEST INFORMATION
  var newRequestInformation = {
    ...widgetInfo.requestInformations,
  }

  var fieldToSortHasBeenRemoved = widgetInfo?.requestInformations?.sort?.uuid === removalConfig.uuid
  var dataUUIDList = []
  if (widgetInfo?.data?.length) dataUUIDList = elementList.map(dataObj => dataObj.id)
  var fieldsAvailableForTopFlop = []

  if (widgetInfo.widgetType === "table") {
    fieldsAvailableForTopFlop = getFieldsDisplayedButNotString(fieldsData, dataUUIDList)
  } else {
    fieldsAvailableForTopFlop = getFieldsListFromUUIDList(fieldsData, dataUUIDList)
  }

  if (fieldToSortHasBeenRemoved && fieldsAvailableForTopFlop.length > 0) {
    newRequestInformation = {
      ...newRequestInformation,
      sort: {
        ...(Boolean(newRequestInformation.sort) && newRequestInformation.sort),
        uuid: fieldsAvailableForTopFlop[0].uuid,
      },
    }
  } else if (fieldToSortHasBeenRemoved && fieldsAvailableForTopFlop.length === 0) {
    var { limit, ...restNewRequestInformation } = newRequestInformation
    newRequestInformation = {
      ...restNewRequestInformation,
      sort: {
        sortingType: sortingTypes.ALL_RESULT,
      },
    }
  }

  return newRequestInformation
}

export const getNewWidgetInfoAfterFieldRemoval = (widgetInfo, fieldsData, removalConfig) => {
  var { elementType, valueId, uuid } = removalConfig

  var elementToUse = getSelectionTypeToUse(elementType)

  if (["counter", "gaugeChart", "cloudWords"].includes(widgetInfo.widgetType)) {
    return {
      ...widgetInfo,
      data: [],
      category: {},
      groupBy: [],
      widgetProps: {
        ...widgetInfo.widgetProps,
        dataNames: [],
      },
    }
  } else if (["category", "groupBy"].includes(elementToUse)) {
    var newGroupBy = widgetInfo.groupBy.filter(groupByElt => groupByElt.uuid !== uuid)
    var widgetInfoAfterGroupByChange = {
      ...widgetInfo,
      category: {},
      groupBy: newGroupBy,
    }
    var newData = widgetInfoAfterGroupByChange.data.map(dataValue => {
      var fieldFound = fieldsData.find(field => field.uuid === dataValue.uuid)
      if (fieldFound) {
        var fieldDataType = fieldFound.dataType
        var newAggFunction = getDefaultAggFunction(
          "data",
          widgetInfoAfterGroupByChange,
          fieldDataType
        )
      }
      return {
        ...dataValue,
        ...(newAggFunction !== undefined && { calculus: newAggFunction }),
      }
    })
    return {
      ...widgetInfoAfterGroupByChange,
      data: newData,
      category: {},
      groupBy: newGroupBy,
    }
  } else {
    var widgetDataSelectedElements = []
    if (Array.isArray(widgetInfo?.[elementToUse])) {
      widgetDataSelectedElements = [...widgetInfo[elementToUse]]
    }
    remove(widgetDataSelectedElements, field => field.valueId === valueId)

    //DATANAMES
    var newDataNames = getDataNamesFromWidgetElementList(widgetDataSelectedElements, fieldsData)

    //REQUEST INFORMATION
    var newRequestInformations = getNewRequestInformations(
      widgetDataSelectedElements,
      widgetInfo,
      fieldsData,
      removalConfig
    )

    var widgetInfoToReturn = {
      ...widgetInfo,
      [elementToUse]: [...widgetDataSelectedElements],
      widgetProps: {
        ...widgetInfo.widgetProps,
        dataNames: newDataNames,
      },
      requestInformations: newRequestInformations,
    }
    return widgetInfoToReturn
  }
}

export const getDefaultTabInfo = (newWidgetId, widgetRef) => {
  return {
    widgetId: newWidgetId, //widgetId is deprecated, use widgetReference instead
    widgetReference: widgetRef,
    name: "My Tabs",
    icon: "fas fa-plus",
    effectType: "underline",
    effectColor: "blue",
    alignment: "left",
  }
}

export const getNewWidgetInfoAfterAddingTab = (widgetInfo, newDefaultTabInfo) => {
  var newWidgetInfo = { ...widgetInfo }
  var newTabsList =
    widgetInfo?.tabsInfos?.tabsList !== undefined ? [...widgetInfo.tabsInfos.tabsList] : []
  newTabsList.push(newDefaultTabInfo)
  newWidgetInfo["tabsInfos"]["tabsList"] = newTabsList
  return newWidgetInfo
}

export const getNewWidgetInfoAfterRemovingTab = (widgetInfo, tabRef) => {
  var newWidgetInfo = { ...widgetInfo }
  var newTabsList =
    widgetInfo?.tabsInfos?.tabsList !== undefined ? [...widgetInfo.tabsInfos.tabsList] : []
  var tabIndexFound = newTabsList.findIndex(tabContent => {
    return tabRef === tabContent.widgetReference
  })
  if (tabIndexFound > -1) {
    newTabsList.splice(tabIndexFound, 1)
    newWidgetInfo["tabsInfos"]["tabsList"] = newTabsList
  }
  return newWidgetInfo
}

export const getNewWidgetInfoAfterTabPropertyChange = (
  oldWidgetInfo,
  widgetReference,
  tabProperty,
  newValue
) => {
  if ([widgetReference, tabProperty, newValue].includes(undefined)) return oldWidgetInfo
  var newTabsListToSet = oldWidgetInfo?.tabsInfos?.tabsList
  if (newTabsListToSet === undefined || !Array.isArray(newTabsListToSet)) return oldWidgetInfo

  var tabIndex = newTabsListToSet.findIndex(
    tabDetail => tabDetail?.widgetReference === widgetReference
  )

  if (tabIndex !== undefined) {
    newTabsListToSet[tabIndex][tabProperty] = newValue
  }

  var newWidgetInfo = {
    ...oldWidgetInfo,
    tabsInfos: {
      ...oldWidgetInfo.tabsInfos,
      tabsList: [...newTabsListToSet],
    },
  }
  return newWidgetInfo
}

export const getNewWidgetInfoAfterGlobalTabPropertyChange = (
  oldWidgetInfo,
  tabProperty,
  newValue
) => {
  if ([tabProperty, newValue].includes(undefined)) return oldWidgetInfo
  var newTabsInfos = oldWidgetInfo?.tabsInfos

  newTabsInfos[tabProperty] = newValue

  var newWidgetInfo = {
    ...oldWidgetInfo,
    tabsInfos: {
      ...newTabsInfos,
    },
  }

  return newWidgetInfo
}

export const insertAt = (array, index, elements) => {
  var arrayToReturn = [...array]
  arrayToReturn.splice(index, 0, elements)
  return arrayToReturn
}

export const valueNameIsACopy = (valueName, partialTrad) => {
  var { COPY } = partialTrad
  if (!valueName) return false

  var regexToTest = [new RegExp(`.*- ${COPY}$`), new RegExp(`.*- Copy$`), new RegExp(`.*- Copie$`)]

  var isACopy = false
  regexToTest.forEach(reg => {
    if (reg.test(valueName)) isACopy = true
  })

  return isACopy
}

export const valueNameIsACopyWithNumber = (valueName, partialTrad = {}) => {
  var { COPY } = partialTrad
  if (!valueName) return false

  var regexToTest = [new RegExp(`.*- Copy \\([0-9]*\\)$`), new RegExp(`.*- Copie \\([0-9]*\\)$`)]

  if (COPY !== undefined) regexToTest.push(new RegExp(`.*- ${COPY} \\([0-9]*\\)$`))

  var isACopy = regexToTest.some(reg => reg.test(valueName))

  return isACopy
}

export const getDuplicateValueName = (widgetInfo, valueToDuplicate, partialTrad) => {
  var { COPY } = partialTrad
  var nameToReturn = `${COPY}`
  var dataNames = widgetInfo.data.map(value => value.name)
  if (valueNameIsACopy(valueToDuplicate?.name, partialTrad)) {
    return `${valueToDuplicate.name} (1)`
  } else if (valueNameIsACopyWithNumber(valueToDuplicate?.name, partialTrad)) {
    var copyNumberIndex = valueToDuplicate.name.length - 2
    var copyNumberStr = valueToDuplicate?.name.charAt(copyNumberIndex)
    var copyNumber = parseInt(copyNumberStr)
    var valueNameAsArray = [...valueToDuplicate.name]

    var newCopyNumber = copyNumber < 9 ? copyNumber + 1 : 9
    valueNameAsArray[copyNumberIndex] = `${newCopyNumber}`

    while (newCopyNumber < 10 && dataNames.includes(valueNameAsArray.join(""))) {
      valueNameAsArray[copyNumberIndex] = `${newCopyNumber}`
      newCopyNumber++
    }

    return valueNameAsArray.join("")
  } else if (valueToDuplicate?.name !== undefined && valueToDuplicate?.name !== "") {
    return `${valueToDuplicate.name} - ${COPY}`
  }
  return nameToReturn
}

export const getNewWidgetInfoAfterValueDuplicate = (widgetInfo, valueToDuplicate, partialTrad) => {
  var valueId = valueToDuplicate.valueId
  var indexOfValueToDuplicate = widgetInfo.data.findIndex(
    dataValue => dataValue.valueId === valueId
  )
  var indexOfnewValue = indexOfValueToDuplicate + 1
  var valueToInsert = {
    ...valueToDuplicate,
    valueId: uuid(),
    name: getDuplicateValueName(widgetInfo, valueToDuplicate, partialTrad),
  }
  var { field, ...restValueToInsert } = valueToInsert
  var newData = insertAt([...widgetInfo.data], indexOfnewValue, restValueToInsert)
  var newDataNames = newData.map(dataValue => dataValue.name)
  var newDataToReturn = {
    ...widgetInfo,
    data: newData,
    widgetProps: {
      ...widgetInfo.widgetProps,
      dataNames: newDataNames,
    },
  }
  return newDataToReturn
}

export const fieldsAreRelated = (firstSourceAndRelObj, secondSourceAndRelObj) => {
  var categoryIsEqual = firstSourceAndRelObj?.category === secondSourceAndRelObj?.category
  var nameIsEqual = firstSourceAndRelObj?.name === secondSourceAndRelObj?.name
  var dataSourceIsEqual = categoryIsEqual && nameIsEqual

  var relationIntersect = false
  if (firstSourceAndRelObj?.relations && secondSourceAndRelObj?.relations) {
    var intersectionArray = getArrayIntersections(
      firstSourceAndRelObj.relations,
      secondSourceAndRelObj.relations
    )
    relationIntersect = Boolean(intersectionArray.length)
  }

  return dataSourceIsEqual || relationIntersect
}

export const getOriginalSourceAndRelation = (
  dataSource,
  relations,
  selectedRow,
  fieldsData = []
) => {
  var dataSourceAndRelations = {
    ...dataSource,
    relations: relations,
  }

  return dataSourceAndRelations
}

export const getEmbeddedSelectedFields = options => {
  const {
    allSelectedDataRow = [],
    widgetInfo = {},
    selectionType = "data",
    firstSourceClicked,
    fieldsData = [],
  } = options
  var newSelectedFields = []
  var sourceAreDifferent = false
  const valueDataCategory = selectionType
  const selectionTypeToUse = getSelectionTypeToUse(selectionType)
  const needDataCategory = ["bubbleChart", "heatMap", "heatMapRisk"].includes(widgetInfo.widgetType)

  allSelectedDataRow.forEach((selectedRow, index) => {
    const { uuid: fieldUuid, alias, field } = selectedRow.data
    var { dataSource, relations, dataType } = field
    var dataSourceAndRelations = getOriginalSourceAndRelation(
      dataSource,
      relations,
      selectedRow,
      fieldsData
    )

    sourceAreDifferent = !fieldsAreRelated(firstSourceClicked, dataSourceAndRelations)

    //the first one and the following if it comes from same source are added
    if (index === 0 || (index > 0 && !sourceAreDifferent)) {
      var finalFieldCalculus = getDefaultAggFunction(selectionTypeToUse, widgetInfo, dataType)

      if (["cloudWords"].includes(widgetInfo.widgetType)) {
        newSelectedFields.push({
          valueId: uuid(),
          id: fieldUuid,
          uuid: fieldUuid,
          name: alias,
          calculus: "",
          conditions: {},
        })
      }

      newSelectedFields.push({
        valueId: uuid(),
        id: fieldUuid,
        uuid: fieldUuid,
        name: alias,
        calculus: finalFieldCalculus,
        conditions: {},
        ...((needDataCategory || selectionTypeToUse === "window") && {
          category: valueDataCategory,
        }),
      })
    }
  })
  return newSelectedFields
}

const getSelectionTypeToUse = selectionType => {
  switch (selectionType) {
    case "name":
    case "x":
    case "y":
    case "value":
    case "id_redirect":
      return "data"
    case "x_groupBy":
    case "y_groupBy":
      return "groupBy"
    case "partitionBy":
    case "orderBy":
    case "frameClause":
      return "window"
    default:
      return selectionType
  }
}

export const getAliasFromSelectedFields = (
  allSelectedDataRow = [],
  firstSourceClicked,
  fieldsData
) => {
  var firstSourceClicked = {}
  var aliasSelected = []
  var sourceAreDifferent = false

  allSelectedDataRow.forEach((selectedRow, index) => {
    const { alias, field } = selectedRow.data
    var { dataSource, relations, dataType } = field
    var dataSourceAndRelations = getOriginalSourceAndRelation(
      dataSource,
      relations,
      selectedRow,
      fieldsData
    )
    sourceAreDifferent = !fieldsAreRelated(firstSourceClicked, dataSourceAndRelations)
    if (index === 0) {
      firstSourceClicked = dataSourceAndRelations
    }
    if (index === 0 || (index > 0 && !sourceAreDifferent)) {
      aliasSelected.push(alias)
    }
  })

  return aliasSelected
}

export const getSourceOfFirstFieldSelected = (allSelectedDataRow, fieldsData) => {
  var firstSourceClicked = {}

  if (Array.isArray(allSelectedDataRow) && allSelectedDataRow.length > 0) {
    var firstRow = allSelectedDataRow[0]
    const { field } = firstRow.data
    var { dataSource, relations } = field
    var dataSourceAndRelations = getOriginalSourceAndRelation(
      dataSource,
      relations,
      firstRow,
      fieldsData
    )

    firstSourceClicked = dataSourceAndRelations
  }

  return firstSourceClicked
}

export const thereIsAtLeastTwoDifferentSource = (
  allSelectedDataRow,
  firstSourceClicked,
  fieldsData
) => {
  var atLeastTwoDiffSource = false
  var sourceAreDifferent = false

  allSelectedDataRow.forEach((selectedRow, index) => {
    const { field } = selectedRow.data
    var { dataSource, relations } = field
    var dataSourceAndRelations = getOriginalSourceAndRelation(
      dataSource,
      relations,
      selectedRow,
      fieldsData
    )

    if (index === 0) firstSourceClicked = dataSourceAndRelations

    sourceAreDifferent = !fieldsAreRelated(firstSourceClicked, dataSourceAndRelations)
    if (sourceAreDifferent) atLeastTwoDiffSource = true
  })

  return atLeastTwoDiffSource
}

export const getWidgetInfoOnAdvancedDataValidation = (
  oldWidgetInfo = {},
  newWidgetsInfosOptions = {}
) => {
  const { newSelectedFields, advancedDataTempConfig } = newWidgetsInfosOptions
  var newData = []
  var valueIndex = advancedDataTempConfig?.index
  if (
    !Array.isArray(newSelectedFields) ||
    newSelectedFields.length === 0 ||
    !Array.isArray(advancedDataTempConfig?.dataList) ||
    valueIndex === undefined ||
    advancedDataTempConfig.dataList.length <= valueIndex
  ) {
    return { ...oldWidgetInfo }
  }
  var newWidgetInfo = { ...oldWidgetInfo }

  var fieldSelectedId = newSelectedFields[0].id
  var newDataList = [...advancedDataTempConfig.dataList]
  let { field, ...restValueConfig } = newDataList[valueIndex]
  newDataList[valueIndex] = {
    ...restValueConfig,
    id: fieldSelectedId,
    uuid: fieldSelectedId,
    calculus: newSelectedFields[0].calculus,
    conditions: newSelectedFields[0].conditions,
  }
  newDataList.forEach(valueConfig => {
    if (valueConfig.uuid !== temporaryIdStr) {
      let { field, ...restValueConfig } = valueConfig
      newData.push(restValueConfig)
    }
  })
  newWidgetInfo = {
    ...newWidgetInfo,
    data: newData,
    widgetProps: {
      ...newWidgetInfo.widgetProps,
      dataNames: newData.map(valueData => valueData.name),
    },
  }

  return newWidgetInfo
}

export const getNewWidgetInfosAfterDatacalogueValidation = (
  oldWidgetInfo,
  newWidgetsInfosOptions
) => {
  var newWidgetInfo = { ...oldWidgetInfo }
  const {
    newSelectedFields,
    advancedDataTempConfig,
    allSelectedDataRow,
    selectionType,
    aliasSelected,
    fieldsData,
  } = newWidgetsInfosOptions

  const isCounter = newWidgetInfo.widgetType === "counter"
  const isCloudWords = newWidgetInfo.widgetType === "cloudWords"

  if (selectionType === "data") {
    newWidgetInfo = {
      ...newWidgetInfo,
      data: newSelectedFields,
      widgetProps: {
        ...newWidgetInfo.widgetProps,
        dataNames: aliasSelected,
      },
    }
    if (isCloudWords && newSelectedFields.length > 0) {
      newWidgetInfo = {
        ...newWidgetInfo,
        groupBy: [newSelectedFields[0]],
      }
    }
  } else if (selectionType === "advancedData") {
    return getWidgetInfoOnAdvancedDataValidation(oldWidgetInfo, newWidgetsInfosOptions)
  } else if (selectionType === "groupBy") {
    var newWidgetData = []
    var newWidgetCategory = {}
    var newWidgetGroupBy = []
    if (newSelectedFields.length) {
      //Value Data calculus
      var valueDataCalculusShouldChange = oldWidgetInfo.data.some(
        valueData => valueData?.calculus === ""
      )
      newWidgetData = oldWidgetInfo.data.map(dataValue => {
        if (dataValue?.calculus !== "") return { ...dataValue }
        let field = getFieldFromUUID(fieldsData, dataValue.uuid)
        let fieldCalculus = getDefaultAggFunctionFromFieldType(field?.dataType)
        return {
          ...dataValue,
          calculus: fieldCalculus,
        }
      })

      //Category
      newWidgetCategory = {
        id: newSelectedFields[0].id,
        sortingType: "default",
      }

      //GroupBy
      newWidgetGroupBy = newSelectedFields.map(field => {
        let initialField = allSelectedDataRow.find(row => row.data.uuid === field.id)
        let fieldType = initialField?.original?.type_field
        let isString = fieldType === "String"
        let useFrequency = fieldType === "Date" || fieldType === "Timestamp"
        let useCountCalculus = isCounter && isString

        var frequencyObj = {}
        if (useFrequency) {
          frequencyObj["frequency"] = "default"
        }

        return {
          ...field,
          calculus: useCountCalculus ? "count" : "sum",
          ...frequencyObj,
        }
      })

      var widgetType = newWidgetInfo?.widgetType
      var canHaveSeveralGroupBy = widgetTypeThatCanHaveSeveralGroupBy.includes(widgetType)
      //for now and until double groupBy is possible, lets keep the first one

      const limitInput = getMaximumNumberFields("groupBy", oldWidgetInfo)
      if (limitInput !== 0 && newWidgetGroupBy.length >= limitInput) {
        newWidgetGroupBy = newWidgetGroupBy.splice(0, limitInput)
      } else if (newWidgetGroupBy.length > 0 && !canHaveSeveralGroupBy) {
        newWidgetGroupBy = [newWidgetGroupBy[0]]
      }
    }
    const actualGroupByList = [...oldWidgetInfo?.groupBy]
    if (actualGroupByList && actualGroupByList.length) {
      const orderGrpBy = []
      actualGroupByList.map(item => {
        if (newWidgetGroupBy.find(grpBy => grpBy.uuid === item.uuid)) {
          orderGrpBy.push(item.uuid)
        }
      })
      newWidgetGroupBy.map(grpBy => {
        if (grpBy?.uuid && !orderGrpBy.includes(grpBy?.uuid)) orderGrpBy.push(grpBy.uuid)
      })

      newWidgetGroupBy = orderBy(newWidgetGroupBy, [grpBy => orderGrpBy.indexOf(grpBy.uuid)])
    }
    newWidgetInfo.category = newWidgetCategory
    newWidgetInfo.groupBy = newWidgetGroupBy
    if (valueDataCalculusShouldChange) newWidgetInfo.data = newWidgetData

    if (isCounter) {
      newWidgetInfo.data = newSelectedFields
    }
  } else if (selectionType === "advancedGroupBy") {
    var newGroupBy = []
    var valueIndex = advancedDataTempConfig.index
    if (newSelectedFields.length > 0 && advancedDataTempConfig.dataList.length > valueIndex) {
      var fieldSelectedId = newSelectedFields[0].id
      var newGroupByList = [...advancedDataTempConfig.dataList]
      let { field, ...restValueConfig } = newGroupByList[valueIndex]

      let initialField = allSelectedDataRow.find(row => row.data.uuid === fieldSelectedId)
      let fieldType = initialField?.original?.type_field
      let isString = fieldType === "String"
      let useFrequency = fieldType === "Date" || fieldType === "Timestamp"
      let useCountCalculus = isCounter && isString

      var frequencyObj = {}
      if (useFrequency) {
        frequencyObj["frequency"] = "default"
      }
      newGroupByList[valueIndex] = {
        ...restValueConfig,
        id: fieldSelectedId,
        uuid: fieldSelectedId,
        calculus: useCountCalculus ? "count" : "sum",
        ...frequencyObj,
      }

      newGroupByList.forEach(valueConfig => {
        if (valueConfig.uuid !== temporaryIdStr) {
          let { field, ...restValueConfig } = valueConfig
          newGroupBy.push(restValueConfig)
        }
      })

      newWidgetInfo.groupBy = newGroupBy
    }
  } else if (selectionType === "dependsOnField") {
    newWidgetInfo.dependsOnField = [newSelectedFields[0]]
    if (newSelectedFields.length) {
      //Value Data calculus
      var valueDataCalculusShouldChange = oldWidgetInfo.data.some(
        valueData => valueData?.calculus === ""
      )
      let newWidgetData = oldWidgetInfo.data.map(dataValue => {
        if (dataValue?.calculus !== "") return { ...dataValue }
        let field = getFieldFromUUID(fieldsData, dataValue.uuid)
        let fieldCalculus = getDefaultAggFunctionFromFieldType(field?.dataType)
        return {
          ...dataValue,
          calculus: fieldCalculus,
        }
      })
      if (valueDataCalculusShouldChange) {
        newWidgetInfo.data = newWidgetData
      }
    }
  } else if (selectionType === "advancedDependsOnField") {
    var newDependsOnField = []
    var valueIndex = advancedDataTempConfig.index
    if (newSelectedFields.length > 0 && advancedDataTempConfig.dataList.length > valueIndex) {
      var fieldSelectedId = newSelectedFields[0].id
      var newDependsOnFieldList = [...advancedDataTempConfig.dataList]
      let { field, ...restValueConfig } = newDependsOnFieldList[valueIndex]
      newDependsOnFieldList[valueIndex] = {
        ...restValueConfig,
        id: fieldSelectedId,
        uuid: fieldSelectedId,
        calculus: newSelectedFields[0].calculus,
        conditions: newSelectedFields[0].conditions,
      }
      newDependsOnFieldList.forEach(valueConfig => {
        if (valueConfig.uuid !== temporaryIdStr) {
          let { field, ...restValueConfig } = valueConfig
          newDependsOnField.push(restValueConfig)
        }
      })

      var valueDataCalculusShouldChange = oldWidgetInfo.data.some(
        valueData => valueData?.calculus === ""
      )
      let newWidgetData = oldWidgetInfo.data.map(dataValue => {
        if (dataValue?.calculus !== "") return { ...dataValue }
        let field = getFieldFromUUID(fieldsData, dataValue.uuid)
        let fieldCalculus = getDefaultAggFunctionFromFieldType(field?.dataType)
        return {
          ...dataValue,
          calculus: fieldCalculus,
        }
      })
      if (valueDataCalculusShouldChange) {
        newWidgetInfo.data = newWidgetData
      }
      newWidgetInfo = {
        ...newWidgetInfo,
        ...(valueDataCalculusShouldChange && { data: newWidgetData }),
        dependsOnField: newDependsOnField,
      }
    }
  } else if (["x", "y", "value", "name", "id_redirect"].includes(selectionType)) {
    newWidgetInfo = getNewBubbleChartWidgetInfos(
      selectionType,
      newWidgetInfo,
      aliasSelected,
      newSelectedFields
    )
  } else if (["x_groupBy", "y_groupBy"].includes(selectionType)) {
    newWidgetInfo = getNewWidgetInfoAfterPutXAndYInGroupBy(
      selectionType,
      newWidgetInfo,
      newSelectedFields
    )
  } else if (selectionType === "lattitude") {
    newWidgetInfo = {
      ...newWidgetInfo,
      lattitude: newSelectedFields,
      widgetProps: {
        ...newWidgetInfo.widgetProps,
        lattitudeNames: aliasSelected,
        lattitudeValueData: newSelectedFields,
      },
    }
  } else if (selectionType === "longitude") {
    newWidgetInfo = {
      ...newWidgetInfo,
      longitude: newSelectedFields,
      widgetProps: {
        ...newWidgetInfo.widgetProps,
        longitudeNames: aliasSelected,
        longitudeValueData: newSelectedFields,
      },
    }
  } else if (["partitionBy", "orderBy", "frameClause"].includes(selectionType)) {
    let newWindow = [...newWidgetInfo.window]

    const indexOfSelectedValue = newWidgetInfo.window.findIndex(
      data => data?.category === selectionType
    )

    if (indexOfSelectedValue > -1) {
      newWindow[indexOfSelectedValue] = newSelectedFields[0]
    } else {
      newWindow.push(...newSelectedFields)
    }

    newWidgetInfo = {
      ...newWidgetInfo,
      window: newWindow,
    }
  }
  return newWidgetInfo
}

const getNewBubbleChartWidgetInfos = (
  selectionType,
  widgetInfos,
  aliasSelected,
  newSelectedFields
) => {
  let newWidgetInfo = { ...widgetInfos }
  let newData = [...newWidgetInfo.data]

  const indexOfSelectedValue = newWidgetInfo.data.findIndex(data => data.category === selectionType)

  if (indexOfSelectedValue > -1) {
    newData[indexOfSelectedValue] = newSelectedFields[0]
  } else {
    newData.push(...newSelectedFields)
  }

  newWidgetInfo = {
    ...newWidgetInfo,
    data: newData,
    widgetProps: {
      ...newWidgetInfo.widgetProps,
      dataNames: aliasSelected,
    },
  }

  return newWidgetInfo
}

const getNewWidgetInfoAfterPutXAndYInGroupBy = (selectionType, widgetInfos, newSelectedFields) => {
  let newWidgetInfo = { ...widgetInfos }
  var newWidgetGroupBy = [...newWidgetInfo.groupBy]
  if (newSelectedFields.length) {
    const indexInGroupBy = newWidgetGroupBy.findIndex(grpBy => grpBy.category === selectionType)
    // If field not in groupBy
    if (indexInGroupBy === -1) {
      newWidgetGroupBy.push(...newSelectedFields)
    }

    newWidgetInfo = {
      ...newWidgetInfo,
      groupBy: newWidgetGroupBy,
    }
  }

  return newWidgetInfo
}

export const fieldHasCorrectDataSource = fullField => {
  return (
    fullField &&
    fullField?.dataSource &&
    fullField.dataSource.hasOwnProperty("category") &&
    fullField.dataSource.hasOwnProperty("name")
  )
}

export const getDataSourceAndRelationFromUUID = (uuid, fieldsData) => {
  var fullField = getFieldFromUUID(fieldsData, uuid)

  if (!uuid || fieldsData.length === 0) return {}

  var objectToReturn = {}
  if (fieldHasCorrectDataSource(fullField)) {
    objectToReturn = {
      ...objectToReturn,
      ...fullField.dataSource,
      relations: fullField?.relations ? fullField.relations : [],
    }
  }
  return objectToReturn
}

export const getDataCatalogueFilterFromWidgetConfig = (widgetInfos, fieldsData) => {
  var firstFieldUUID = ""
  if (widgetInfos?.data?.length) firstFieldUUID = widgetInfos.data[0]?.id
  else if (widgetInfos?.groupBy?.length) firstFieldUUID = widgetInfos.groupBy[0]?.id

  //at the moment, a choice have been taken that we don't take conditions
  // into account because, it does not break widget.

  var sourceAndRelation = {}
  if (firstFieldUUID !== "") {
    var dataSourceAndRelationTemp = getDataSourceAndRelationFromUUID(firstFieldUUID, fieldsData)
    if (dataSourceAndRelationTemp !== undefined) {
      sourceAndRelation = { ...dataSourceAndRelationTemp }
    }
  }

  if (widgetInfos?.widgetType === "calendar") {
    sourceAndRelation["authorizedFieldType"] = ["Date", "Timestamp"]
  }

  if (!["dropdownList", "table", "ag_table"].includes(widgetInfos?.widgetType)) {
    sourceAndRelation["unAuthorizedFieldType"] = ["Array"]
  }

  return sourceAndRelation
}

export const showTabsTabInWidgetConfig = widgetInfo => {
  return widgetInfo?.widgetType === "multiTabWidget"
}

export const showDataTabInWidgetConfig = (widgetInfo, multiTabSelected) => {
  if (widgetInfo?.widgetType === "multiTabWidget") {
    if (multiTabSelected === undefined) return false
    var tabKeys = Object.keys(multiTabSelected)
    return tabKeys.length > 0
  }
  return !["redirectButton", "image", "basicText", "lastSampleWidget", "actualityList"].includes(
    widgetInfo?.widgetType
  )
}

export const showStyleTabInWidgetConfig = (widgetInfo, multiTabSelected) => {
  if (widgetInfo?.widgetType === "multiTabWidget") {
    if (multiTabSelected === undefined) return false
    var tabKeys = Object.keys(multiTabSelected)
    return tabKeys.length > 0
  }
  return true
}

export const numberAuthorisedValue = {
  counter: { dataNumberMax: 1, groupByMax: 0 },
  //pie
  pieChart: { dataNumberMax: 2, groupByMax: 1 },
  semiPieChart: { dataNumberMax: 2, groupByMax: 1 },
  //bar
  histogram: { groupByMax: 1 },
  stackedBar: { groupByMax: 1 },
  stackedBar100: { groupByMax: 1 },
  horizontalBarChart: { groupByMax: 1 },
  horizontal: { groupByMax: 1 },
  vertical: { groupByMax: 1 },
  //line
  lineChart: { groupByMax: 1 },
  cumulativeLineChart: { groupByMax: 1 },
  stackedArea: { groupByMax: 1 },
  table: {},
  multiGauge: {},
  treeMap: { dataNumberMax: 1 },
  radarChart: { groupByMax: 1 },
  //resetConfig
  // gaugeChart
  // progressBar
  // evolutionWidget
  // rangeFilter
}

export const shouldResetConfigOnTypeChange = (widgetInfo, newWidgetType) => {
  var resetWigetConfig = false

  var newAuthorizedConfig = numberAuthorisedValue?.[newWidgetType]
  if (newAuthorizedConfig === undefined) return true

  var dataMax = newAuthorizedConfig?.dataNumberMax
  var groupByMax = newAuthorizedConfig?.groupByMax
  if (dataMax !== undefined && widgetInfo.data.length > dataMax) {
    resetWigetConfig = true
  } else if (groupByMax !== undefined && widgetInfo.groupBy.length > groupByMax) {
    resetWigetConfig = true
  }

  return resetWigetConfig
}

export const getNewWidgetInfoOnChangeType = (newWidgetType, widgetInfo, options) => {
  const {
    sideMenuColor,
    primaryActionColor,
    alternativeActionColor,
    illustrationColor,
    businessColorPalettes,
    businessDefaultPaletteId,
    publicColorPalettes,
    languageId,
  } = options

  var needResetConfig = shouldResetConfigOnTypeChange(widgetInfo, newWidgetType)

  const { colorPalette, listColors, defaultColorPalette } = formatColorPalettes(
    businessColorPalettes,
    businessDefaultPaletteId,
    publicColorPalettes
  )

  var defaultPropsOptions = {
    sideMenuColor,
    primaryActionColor,
    alternativeActionColor,
    illustrationColor,
    colorPalette,
    defaultColorPalette,
    listColors,
  }

  var defaultWidgetProps = getWidgetDefaultProps(newWidgetType, languageId, defaultPropsOptions)

  var newDataNames = []
  if (needResetConfig) {
    newDataNames = []
  } else if (Array.isArray(widgetInfo?.widgetProps?.dataNames)) {
    newDataNames = [...widgetInfo.widgetProps.dataNames]
  }

  var newWidget = {
    ...widgetInfo,
    widgetType: newWidgetType,
    ...(needResetConfig && {
      data: [],
      groupBy: [],
      conditions: {},
      category: {},
    }),
    widgetProps: {
      //clear previous widget props
      ...defaultWidgetProps,
      dataNames: [...newDataNames],
    },
  }
  return newWidget
}

export const getSelectedTopFlopValue = (widgetInfo, displayedResultsForTopFlop) => {
  let selectedTopFlopValue
  if (widgetInfo?.requestInformations?.sort?.sortingType) {
    selectedTopFlopValue = displayedResultsForTopFlop.find(item => {
      return item.value === widgetInfo?.requestInformations?.sort?.sortingType
    })
  } else {
    selectedTopFlopValue = displayedResultsForTopFlop[0]
  }
  return selectedTopFlopValue
}

export const getTopFlopFieldToShowInSelector = (
  widgetInfo,
  fieldsAvailableForTopFlopSelection,
  partialTrad
) => {
  const { DISPLAYED_FIELDS, OTHER_FIELDS } = partialTrad
  let dataFields = widgetInfo?.data.map(field => field.name)
  let groupByFields = widgetInfo?.groupBy.map(field => field.name)

  let displayedFields = []
  let otherFields = []

  fieldsAvailableForTopFlopSelection.forEach(field => {
    if (dataFields.includes(field?.tags?.label) || groupByFields.includes(field?.tags?.label)) {
      displayedFields.push({ value: field.uuid, label: field?.tags?.label })
    } else {
      otherFields.push({ value: field.uuid, label: field?.tags?.label })
    }
  })
  let topFlopFields = [
    { label: DISPLAYED_FIELDS, options: displayedFields },
    { label: OTHER_FIELDS, options: otherFields },
  ]
  return topFlopFields
}

export const getSelectedTopFlopField = (widgetInfo, fields) => {
  let selectedTopFlopField
  var fieldUuid = widgetInfo?.requestInformations?.sort?.uuid
  if (fieldUuid) {
    let selectedField = fields.find(item => item.uuid === fieldUuid)
    selectedTopFlopField = {
      value: selectedField?.uuid,
      label: selectedField?.tags?.label,
    }
  }
  return selectedTopFlopField
}

export const getTopFlopStringContent = (widgetInfo, fieldsData, partialTrad) => {
  var arrayToStringify = []
  var begin = partialTrad.THAT_IS_TO_SAY
  var limit = widgetInfo?.requestInformations?.limit || 10
  var sortingType = widgetInfo?.requestInformations?.sort?.sortingType
  var groupByFieldLabel = "undefined GroupBy Field"
  var topFlopFieldLabel = "undefined Top/Flop Field"

  arrayToStringify.push(begin)

  if (widgetInfo?.data?.length === 0) return ""

  var topFlop = ""
  if (sortingType === sortingTypes.BEST_RESULT) {
    topFlop = `${"TOP"} ${limit}`
  } else if (sortingType === sortingTypes.WORST_RESULT) {
    topFlop = `${"FLOP"} ${limit}`
  } else if (sortingType === sortingTypes.ALL_RESULT) {
    topFlop = partialTrad.ALL_MASCULINE
  }

  if (topFlop !== "") arrayToStringify.push(topFlop)

  if (widgetInfo?.groupBy?.length > 0) {
    var groupByField = getFieldFromUUID(fieldsData, widgetInfo.groupBy[0].id)
    if (groupByField?.tags?.label) groupByFieldLabel = groupByField.tags.label
    var groupByBloc = `${partialTrad.OF} "${groupByFieldLabel}"`
    arrayToStringify.push(groupByBloc)
  }

  if (widgetInfo?.requestInformations?.sort?.uuid) {
    var topFlopField = getFieldFromUUID(fieldsData, widgetInfo?.requestInformations?.sort?.uuid)
    if (topFlopField?.tags?.label) topFlopFieldLabel = topFlopField.tags.label
    if (topFlopFieldLabel.length > 25) topFlopFieldLabel = topFlopFieldLabel.slice(0, 22) + "..."

    var topFlopBloc = `${partialTrad.FOR} "${topFlopFieldLabel}"`
    arrayToStringify.push(topFlopBloc)
  }
  return arrayToStringify.join(" ")
}

export const shouldShowWidgetTypeSelector = (multiTabWidgetInfo, widgetInfo) => {
  const isUndefinedOrMulti = [undefined, "multiTabWidget", "actualityList"].includes(
    multiTabWidgetInfo?.widgetType
  )
  const isPipeline = widgetInfo?.widgetType === "pipeline"
  const hideWidgetTypeSelector =
    isUndefinedOrMulti || isFilterWidget(widgetInfo) || isTextWidget(widgetInfo) || isPipeline
  return !hideWidgetTypeSelector
}

export const createNewWidget = options => {
  const {
    businessColorPalettes,
    businessDefaultPaletteId,
    publicColorPalettes,
    widgetSpecification,
    colors,
    languageId,
  } = options

  const { sideMenuColor, primaryActionColor, alternativeActionColor, illustrationColor } = colors

  const { colorPalette, listColors, defaultColorPalette } = formatColorPalettes(
    businessColorPalettes,
    businessDefaultPaletteId,
    publicColorPalettes
  )

  var optionsInWidgetConstructor = {
    sideMenuColor,
    primaryActionColor,
    alternativeActionColor,
    illustrationColor,
    colorPalette,
    defaultColorPalette,
    listColors,
  }

  return newWidgetConstructor(widgetSpecification, languageId, optionsInWidgetConstructor)
}

export const getMultitabWidgetInWhichThisWidgetIs = (widgetsList, widgetRefToFind) => {
  return widgetsList.find(widget => {
    var tabsList = widget?.tabsInfos?.tabsList
    if (!Array.isArray(tabsList)) return false
    var widgetIsInside = tabsList.find(tabInfos => tabInfos.widgetReference === widgetRefToFind)
    return widgetIsInside ? true : false
  })
}

export const getNewMultiTabWidgetAfterDuplicate = (
  previousMultiTabWidget = {},
  widgetTabsOpen = {},
  newWidgetRef,
  newWidgetId
) => {
  if (newWidgetRef === undefined) return { ...previousMultiTabWidget }

  var newTabInfoToAdd = {
    ...widgetTabsOpen,
    widgetReference: newWidgetRef,
    widgetId: newWidgetId,
  }

  var newMultiTabWidget = {
    ...previousMultiTabWidget,
    tabsInfos: {
      ...previousMultiTabWidget.tabsInfos,
      tabsList: [...previousMultiTabWidget.tabsInfos.tabsList, newTabInfoToAdd],
    },
  }

  return newMultiTabWidget
}

export const getNewWorkingWidgetListOnDuplicate = (
  previousWidgetList,
  widgetTabsOpen,
  newWidgetRef
) => {
  var widgetToDuplicate = previousWidgetList.find(
    widget => widget.multiTabReference === widgetTabsOpen.widgetReference
  )
  if (widgetToDuplicate === undefined) return [...previousWidgetList]

  var multiTabFound = getMultitabWidgetInWhichThisWidgetIs(
    previousWidgetList,
    widgetTabsOpen.widgetReference
  )
  if (multiTabFound === undefined) return [...previousWidgetList]

  var newWidgetId = uuid()
  var newMultiTabWidget = getNewMultiTabWidgetAfterDuplicate(
    multiTabFound,
    widgetTabsOpen,
    newWidgetRef,
    newWidgetId
  )

  var newWidget = {
    ...widgetToDuplicate,
    _id: { $oid: newWidgetId },
    multiTabReference: newWidgetRef,
  }

  var newWidgetList = previousWidgetList.map(widget => {
    if (widget._id.$oid === multiTabFound._id.$oid) return newMultiTabWidget
    return widget
  })
  return [...newWidgetList, newWidget]
}

export const getWidgetLayoutToUse = (widgetLayout, widgetType) => {
  const defaultLayout = {
    w: 6,
    h: 6,
    x: 0,
    y: 0,
  }
  if (!widgetLayout) return defaultLayout
  const isPipeline = widgetType === "pipeline"
  if (isPipeline) return defaultLayout
  else return widgetLayout
}
